import { useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "../../utils/styles/modal.css";
import "./ModalAddUser.css";
import { userService } from "../../services/user.service";
import { closeModal, showModal } from "../../utils/functions/modal";

const ModalAddUser = ({ setMessage, onSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const clearInputs = () => {
    setUsername("");
    setPassword("");
  };

  const handleSubmitUser = async (e) => {
    e.preventDefault();

    closeModal(".container-modal-add-user");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Creando usuario...",
      status: 1000,
    });

    const response = await userService.addUser({
      username: username.trim(),
      password,
    });

    setTimeout(() => {
      if (response.data.status === 200) {
        clearInputs();
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1000);
  };

  return (
    <div className="container-modal container-modal-add-user">
      <div className="modal modal-add-user">
        <div className="header-modal">
          <h3>Agregar Usuario</h3>
          <button onClick={() => closeModal(".container-modal-add-user")}>
            <img src={CloseIcon} alt="" />
          </button>
        </div>
        <form onSubmit={handleSubmitUser} className="body-modal">
          <div className="input">
            <label htmlFor="usernameAddUser">Usuario</label>
            <input
              type="text"
              id="usernameAddUser"
              name="usernameAddUser"
              required
              onChange={(e) => setUsername(e.target.value)}
              value={username}
              placeholder="nombre@colibriapp.com"
            />
          </div>
          <div className="input">
            <label htmlFor="passwordAddUser">Contraseña</label>
            <input
              type="password"
              id="passwordAddUser"
              name="passwordAddUser"
              required
              minLength={8}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              placeholder="Mínimo 8 caracteres"
            />
          </div>

          <button className="btn-add-product">AGREGAR USUARIO</button>
        </form>
      </div>
    </div>
  );
};

export default ModalAddUser;
